export default __webpack_public_path__ + "static/media/i_x_b_02.44879642.svg";